module.exports = __webpack_public_path__ + "img/f4.06395368.jpg";